"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = _interopRequireDefault(require("lodash"));
var _reactRouterDom = require("react-router-dom");
var _reactUse = require("react-use");
var _react = _interopRequireWildcard(require("react"));
var _reactLoading = _interopRequireDefault(require("react-loading"));
var _Translations = require("react-platform-components/dist/Translations");
var _reactRedux = require("react-redux");
var _Utils = require("../components/Utils");
var _config = require("../config");
var _ChatActions = require("./ChatActions");
var _ChatsSidebar = _interopRequireDefault(require("../components/ChatsSidebar"));
var _Conversation = _interopRequireDefault(require("../components/Conversation"));
var _index = require("../config/index.js");
var _MakePropositionDialog = _interopRequireDefault(require("./dialogs/MakePropositionDialog"));
var _urlJoin = _interopRequireDefault(require("url-join"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var drawerWidth = 400;
var headerHeight = 200;
var ShoppingCart = null;
try {
  ShoppingCart = require("react-platform-shoppingcart/dist/NewShoppingCart/ShoppingCart");
} catch (e) {}
var useStyles = (0, _core.makeStyles)(function (theme) {
  var _contentCardWrapper;
  return {
    toolbar: {
      paddingLeft: '16px',
      paddingRight: '16px',
      backgroundColor: theme.palette.primary.main,
      background: "#fff !important"
    },
    toolbarProposition: {
      paddingLeft: "16px",
      paddingRight: "16px",
      backgroundColor: "white",
      background: "#fff !important"
    },
    avatar: {
      background: '#f5f5f5',
      color: theme.palette.primary.main
    },
    avatarProduct: _defineProperty({
      background: "#f5f5f5",
      color: theme.palette.primary.main,
      borderRadius: "8px",
      width: "80px",
      height: "80px",
      border: "1px solid #E1E2E1",
      margin: "20px 0",
      cursor: "pointer"
    }, theme.breakpoints.down('sm'), {
      marginTop: 5,
      marginBottom: 5,
      width: 48,
      height: 48
    }),
    content: {
      display: 'flex',
      flex: '1 1 100%',
      minHeight: 0
    },
    contentCard: {
      backgroundColor: '#F8F8F8',
      boxShadow: theme.shadows[1],
      display: 'flex',
      flex: '1 1 100%',
      flexDirection: 'row',
      minHeight: 0,
      overflow: 'hidden',
      position: 'relative'
    },
    contentCardWrapper: (_contentCardWrapper = {
      display: 'flex',
      flex: '1 0 auto',
      flexDirection: 'column',
      margin: '0 auto',
      maxHeight: '100%',
      maxWidth: '100%',
      minWidth: '0',
      padding: 0,
      position: 'relative'
    }, _defineProperty(_contentCardWrapper, theme.breakpoints.down('sm'), {
      padding: 24
    }), _defineProperty(_contentCardWrapper, theme.breakpoints.down('xs'), {
      padding: 12
    }), _contentCardWrapper),
    contentWrapper: {
      background: "linear-gradient(to bottom, ".concat((0, _Utils.fade)(theme.palette.background.paper, 0.8), " 0,").concat((0, _Utils.fade)(theme.palette.background.paper, 0.6), " 20%,").concat((0, _Utils.fade)(theme.palette.background.paper, 0.8), ")"),
      display: 'flex',
      flex: '1 1 100%',
      flexDirection: 'column',
      zIndex: 10
    },
    drawerPaper: _defineProperty({
      height: '100%',
      maxWidth: '100%',
      overflow: 'hidden',
      width: drawerWidth
    }, theme.breakpoints.up('md'), {
      position: 'relative'
    }),
    root: {
      backgroundColor: theme.palette.background.default,
      display: 'flex',
      flex: '1 1 auto',
      flexDirection: 'row',
      height: '100%',
      minHeight: '100%',
      position: 'relative'
    },
    topBg: {
      backgroundSize: 'cover',
      height: headerHeight,
      left: 0,
      pointerEvents: 'none',
      position: 'absolute',
      right: 0,
      top: 0
    },
    loader: {
      fill: "".concat(theme.palette.primary.main, " !important")
    },
    offerButton: {
      color: "black",
      cursor: "pointer"
    },
    buyButton: {
      backgroundColor: theme.palette.third.main,
      cursor: "pointer",
      color: "black",
      borderRadius: "8px"
    },
    wrapper: _defineProperty({
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      alignContent: "center",
      width: "100%"
    }, theme.breakpoints.down('sm'), {
      flexDirection: 'column',
      alignItems: "start"
    }),
    flexCentredWithGap: {
      display: "flex",
      gap: "15px",
      justifyContent: "center",
      alignContent: "center",
      alignItems: "center"
    },
    flexColumnBlack: {
      display: "flex",
      flexDirection: "column",
      color: "black"
    },
    buttonsHeaderWrapper: _defineProperty({
      display: "flex",
      gap: "10px",
      justifyItems: "center",
      justifyContent: "center",
      alignItems: "center"
    }, theme.breakpoints.down('sm'), {
      paddingBottom: 10,
      alignSelf: 'flex-start'
    }),
    mainContainer: _defineProperty({
      height: 'calc(100vh - 64px)'
    }, theme.breakpoints.down('sm'), {
      height: 'calc(100vh - 100px)'
    }),
    contactListButton: {
      alignSelf: 'flex-start',
      marginTop: 5
    }
  };
});
var defaultConversation = _Conversation.default;
function Chat(props) {
  var _selectedContact$user, _selectedContact$user2, _selectedContact$user3, _selectedContact$user4, _selectedContact$user5, _selectedContact$prod, _selectedContact$prod2, _selectedContact$prod3, _proposition$proposit, _selectedContact$prod4, _selectedContact$prod5;
  var Conversation = props.conversation || defaultConversation;
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var isMobile = (0, _core.useMediaQuery)(function (theme) {
    return theme.breakpoints.down('md');
  }, {
    noSsr: true
  });
  (0, _reactUse.useTitle)(props.intl.formatMessage({
    id: "Chat page title",
    defaultMessage: "Chat page title"
  }));
  var params = (0, _reactRouterDom.useParams)();
  var query = new URLSearchParams(window.location.search);
  var productId = query.get("product");
  var userId = query.get("user");
  var _useSelector = (0, _reactRedux.useSelector)(function (_ref) {
      var chatReducer = _ref.chatReducer,
        auth = _ref.auth,
        localeReducer = _ref.localeReducer;
      return {
        contacts: chatReducer.contacts,
        chat: chatReducer.chat,
        getContactsInProgress: chatReducer.getContactsInProgress,
        mobileChatsSidebarOpen: chatReducer.mobileChatsSidebarOpen,
        selectedContactId: chatReducer.selectedContactId,
        user: auth.user,
        locale: localeReducer.locale
      };
    }),
    contacts = _useSelector.contacts,
    chat = _useSelector.chat,
    getContactsInProgress = _useSelector.getContactsInProgress,
    mobileChatsSidebarOpen = _useSelector.mobileChatsSidebarOpen,
    selectedContactId = _useSelector.selectedContactId,
    user = _useSelector.user,
    locale = _useSelector.locale;
  var handleAddProductToShoppingCart = function handleAddProductToShoppingCart() {
    var contact = _lodash.default.find(contacts, function (item) {
      return item.id === selectedContactId;
    });
    localStorage.setItem('cart', JSON.stringify({
      uuid: contact.product.uuid
    }));
    dispatch({
      type: _ChatActions.ADD_TO_CART_AFTER_PROPOSITION,
      product: {
        uuid: contact.product.uuid
      },
      onSuccess: function onSuccess() {
        dispatch({
          history: props.history,
          to: '/cart',
          type: 'REDIRECT'
        });
      }
    });
  };
  (0, _react.useEffect)(function () {
    var isSelectedContact = Boolean(params.id);
    // check if the contacts sidebar is open
    var mobileChatSidebarIsOpen = !isSelectedContact && isMobile && !userId && !productId;
    if (_lodash.default.isEmpty(contacts)) {
      dispatch({
        type: _ChatActions.GET_CONTACTS_START,
        onSuccess: function onSuccess() {
          // Open the contacts sidebar on first time when we are on mobile
          if (mobileChatSidebarIsOpen) {
            dispatch({
              type: _ChatActions.OPEN_MOBILE_CHATS_SIDEBAR
            });
          }
        }
      });
    } else {
      // Open the contacts sidebar on first time when we are on mobile
      if (mobileChatSidebarIsOpen) {
        dispatch({
          type: _ChatActions.OPEN_MOBILE_CHATS_SIDEBAR
        });
      }
    }
    return function () {
      dispatch({
        type: _ChatActions.CLOSE_CHAT_PANEL
      });
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (userId) {
      dispatch({
        type: 'CREATE_CONVERSATION_START',
        productId: productId,
        userId: userId
      });
    }
  }, [productId, userId]);
  var openMobileChatsSidebar = function openMobileChatsSidebar() {
    dispatch({
      type: _ChatActions.OPEN_MOBILE_CHATS_SIDEBAR
    });
  };
  var closeMobileChatsSidebar = function closeMobileChatsSidebar() {
    dispatch({
      type: _ChatActions.CLOSE_MOBILE_CHATS_SIDEBAR
    });
  };
  //TODO:we musnt handle locale in the code base react part. Must be recoded
  var handleUserClick = function handleUserClick(user) {
    return function (event) {
      if (user.store !== null) {
        if (_index.DEFAULT_LOCALE !== locale) {
          var _user$store;
          window.open("".concat(_config.BASE_URL).concat(locale, "/").concat(_index.STORE_PAGE, "/").concat(user === null || user === void 0 ? void 0 : (_user$store = user.store) === null || _user$store === void 0 ? void 0 : _user$store.id), '_blank');
        } else {
          var _user$store2;
          window.open("".concat(_config.BASE_URL).concat(_index.STORE_PAGE, "/").concat(user === null || user === void 0 ? void 0 : (_user$store2 = user.store) === null || _user$store2 === void 0 ? void 0 : _user$store2.id), '_blank');
        }
      } else {
        if (_index.DEFAULT_LOCALE !== locale) {
          window.open("".concat(_config.BASE_URL).concat(locale, "/").concat(_index.USER_INFO_ENDPOINT, "/").concat(user === null || user === void 0 ? void 0 : user.id), '_blank');
        } else {
          window.open("".concat(_config.BASE_URL).concat(_index.USER_INFO_ENDPOINT, "/").concat(user === null || user === void 0 ? void 0 : user.id), '_blank');
        }
      }
    };
  };
  var handleShowProductInfo = function handleShowProductInfo(product) {
    return function () {
      window.open("".concat(_config.BASE_URL).concat(_index.PRODUCTS_ENDPOINT, "/").concat(product === null || product === void 0 ? void 0 : product.id), '_blank');
    };
  };
  var selectedContact = contacts.find(function (contact) {
    return (contact === null || contact === void 0 ? void 0 : contact.id) === selectedContactId;
  });

  // show the first name and the last name if exists
  var contactName = "".concat(selectedContact === null || selectedContact === void 0 ? void 0 : (_selectedContact$user = selectedContact.user) === null || _selectedContact$user === void 0 ? void 0 : _selectedContact$user.first_name, " ").concat((selectedContact === null || selectedContact === void 0 ? void 0 : (_selectedContact$user2 = selectedContact.user) === null || _selectedContact$user2 === void 0 ? void 0 : _selectedContact$user2.last_name) || "");
  if (_lodash.default.isEmpty(contacts) && getContactsInProgress) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xl-9 col-lg-9 content-right-offset"
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 150
      }
    }, /*#__PURE__*/_react.default.createElement(_reactLoading.default, {
      type: 'bars',
      className: classes.loader,
      height: 60,
      width: 60
    })));
  }
  if (_lodash.default.isEmpty(contacts) && !getContactsInProgress) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xl-9 col-lg-9 content-right-offset"
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 120
      }
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "icon-material-outline-forum ",
      style: {
        fontSize: 78,
        color: _config.MAIN_CHAT_COLOR
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 10,
        textAlign: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h5",
      style: {
        color: _config.MAIN_CHAT_COLOR
      }
    }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Aucune conversation pour le moment",
      defaultMessage: "Aucune conversation pour le moment"
    }))));
  }
  var proposition = chat.find(function (item) {
    return item.subject === "proposition";
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('col-xl-9 col-lg-9 content-right-offset margin-bottom-40', classes.mainContainer)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.topBg
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentCardWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentCard
  }, /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    mdUp: true
  }, /*#__PURE__*/_react.default.createElement(_core.Drawer, {
    className: "h-full absolute z-20",
    variant: "temporary",
    anchor: "left",
    open: mobileChatsSidebarOpen,
    onClose: closeMobileChatsSidebar,
    classes: {
      paper: (0, _classnames.default)(classes.drawerPaper, "absolute pin-l")
    },
    ModalProps: {
      BackdropProps: {
        classes: {
          root: "absolute"
        }
      },
      keepMounted: true
    }
  }, /*#__PURE__*/_react.default.createElement(_ChatsSidebar.default, null))), /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    smDown: true
  }, /*#__PURE__*/_react.default.createElement(_core.Drawer, {
    className: "h-full z-20",
    variant: "permanent",
    open: true,
    classes: {
      paper: classes.drawerPaper
    }
  }, /*#__PURE__*/_react.default.createElement(_ChatsSidebar.default, null))), /*#__PURE__*/_react.default.createElement("main", {
    className: (0, _classnames.default)(classes.contentWrapper, "z-10")
  }, !chat ? /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col flex-1 items-center justify-center p-24"
  }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: "rounded-full p-48"
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: "block text-64",
    color: "secondary"
  }, "chat")), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: "hidden md:flex px-16 pb-24 mt-24 text-center",
    color: "textSecondary"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "S\xE9lectionnez un contact pour d\xE9marrer une conversation",
    defaultMessage: "S\xE9lectionnez un contact pour d\xE9marrer une conversation"
  })), /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "outlined",
    color: "primary",
    className: "flex md:hidden normal-case mt-24",
    onClick: openMobileChatsSidebar
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "S\xE9lectionnez un contact pour d\xE9marrer une conversation",
    defaultMessage: "S\xE9lectionnez un contact pour d\xE9marrer une conversation"
  }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    mdUp: !selectedContactId
  }, /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    className: "w-full",
    position: "static",
    elevation: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    className: classes.toolbarProposition
  }, window.innerWidth < 600 && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    color: "primary",
    "aria-label": "Open drawer",
    onClick: openMobileChatsSidebar,
    className: (0, _classnames.default)('flex md:hidden sm:flex-start', classes.contactListButton)
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "arrow_back")), selectedContact && _lodash.default.isEmpty(proposition) && _lodash.default.isEmpty(selectedContact.product) ? /*#__PURE__*/_react.default.createElement("div", {
    className: "flex items-center cursor-pointer",
    onClick: handleUserClick(selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.user)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "relative mx-4"
  }, selectedContact !== null && selectedContact !== void 0 && (_selectedContact$user3 = selectedContact.user.avatar) !== null && _selectedContact$user3 !== void 0 && _selectedContact$user3.default ? /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: classes.avatar,
    alt: contactName,
    src: (0, _urlJoin.default)(_config.BASE_URL, selectedContact === null || selectedContact === void 0 ? void 0 : (_selectedContact$user4 = selectedContact.user) === null || _selectedContact$user4 === void 0 ? void 0 : (_selectedContact$user5 = _selectedContact$user4.avatar) === null || _selectedContact$user5 === void 0 ? void 0 : _selectedContact$user5.default)
  }) : /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: classes.avatar,
    alt: contactName
  }, contactName[0])), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    color: "inherit",
    className: "text-12 font-600"
  }, contactName)) : /*#__PURE__*/_react.default.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.flexCentredWithGap
  }, selectedContact && /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: classes.avatarProduct,
    src: !_lodash.default.isEmpty(selectedContact === null || selectedContact === void 0 ? void 0 : (_selectedContact$prod = selectedContact.product) === null || _selectedContact$prod === void 0 ? void 0 : (_selectedContact$prod2 = _selectedContact$prod.main_image) === null || _selectedContact$prod2 === void 0 ? void 0 : _selectedContact$prod2.name) ? (0, _urlJoin.default)(_config.BASE_URL, selectedContact === null || selectedContact === void 0 ? void 0 : (_selectedContact$prod3 = selectedContact.product.main_image) === null || _selectedContact$prod3 === void 0 ? void 0 : _selectedContact$prod3.name["500x500"]) : undefined,
    alt: selectedContact.user.first_name[0].toUpperCase(),
    onClick: handleShowProductInfo(selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.product)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.flexColumnBlack
  }, /*#__PURE__*/_react.default.createElement("span", {
    onClick: handleShowProductInfo(selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.product),
    style: {
      cursor: "pointer"
    }
  }, selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.product.name), selectedContact && (proposition === null || proposition === void 0 ? void 0 : (_proposition$proposit = proposition.proposition) === null || _proposition$proposit === void 0 ? void 0 : _proposition$proposit.status) !== "accepted" && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption"
  }, selectedContact.product.original_price && selectedContact.product.original_price + "€"), selectedContact && (proposition === null || proposition === void 0 ? void 0 : proposition.proposition.status) === "accepted" && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption"
  }, selectedContact.product.original_price && /*#__PURE__*/_react.default.createElement("del", null, " ".concat(selectedContact.product.original_price, " \u20AC")), /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: " " + (proposition === null || proposition === void 0 ? void 0 : proposition.proposition.price) + " €",
    defaultMessage: " " + (proposition === null || proposition === void 0 ? void 0 : proposition.proposition.price) + " €"
  })))), _config.PROPOSITIONS_USED && selectedContact && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.buttonsHeaderWrapper
  }, _lodash.default.toString(selectedContact === null || selectedContact === void 0 ? void 0 : (_selectedContact$prod4 = selectedContact.product) === null || _selectedContact$prod4 === void 0 ? void 0 : (_selectedContact$prod5 = _selectedContact$prod4.user) === null || _selectedContact$prod5 === void 0 ? void 0 : _selectedContact$prod5.id) !== _lodash.default.toString(user === null || user === void 0 ? void 0 : user.id) && /*#__PURE__*/_react.default.createElement(_MakePropositionDialog.default, {
    product: selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.product,
    user: user
  }), ShoppingCart && _lodash.default.toString(selectedContact.product.user.id) !== _lodash.default.toString(user.id) && /*#__PURE__*/_react.default.createElement(_core.Button, {
    color: "secondary",
    size: "small",
    variant: "contained",
    className: classes.buyButton,
    onClick: function onClick() {
      return handleAddProductToShoppingCart();
    }
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Acheter",
    defaultMessage: "Acheter"
  }))))))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/_react.default.createElement(Conversation, null))))))));
}
var _default = (0, _Translations.injectIntl)(Chat);
exports.default = _default;